export default __webpack_public_path__ + "static/media/git.6548a2fc.svg";